/**
 * "Beta" labels (nav, dashboard) show for 7 days after this UTC instant.
 * Change `BETA_BADGE_SINCE_MS` to the release moment you want to count from.
 */
const BETA_BADGE_SINCE_MS = Date.UTC(2026, 4, 11, 0, 0, 0, 0); // 2026-05-11 00:00 UTC

const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

export function isBetaBadgeVisible(): boolean {
  return Date.now() < BETA_BADGE_SINCE_MS + SEVEN_DAYS_MS;
}
